import React, { FC } from 'react';
import { StyledModal } from './styles';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { SecondaryButton } from 'common/components';
import { ReactComponent as SuccessIcon } from 'applicaiton/assets/success-icon.svg';
import { useTranslation } from 'react-i18next';
import { Modal } from '@mui/material';
import { SuccessModalProps } from './modules';
require('dayjs/locale/pt');
require('dayjs/locale/fr');

const SuccessDocumentDeletedModal: FC<SuccessModalProps> = ({
  onClose,
  documentName,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={true}>
      <StyledModal>
        <CloseIcon onClick={onClose} />
        <div>
          <SuccessIcon />
          <p>
            {t('appointment.successDeleted.titlePart1')}{' '}
            <span>{documentName}</span>{' '}
            {t('appointment.successDeleted.titlePart2')}
          </p>
          <SecondaryButton onClick={onClose}>
            {t('appointment.successDeleted.ok')}
          </SecondaryButton>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default SuccessDocumentDeletedModal;
